import transpose from "./transpose";

export default function() {
  return transpose(arguments);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/zip.js
// module id = 1636
// module chunks = 3